import React from "react";
import { locName } from "../../utils/helpers";

function Execution({state,dispatch,t,TaskEnginePanel}){
  const {locFilter,locations}=state;
  const locLabel=locFilter?locName(locations,locFilter):"";
  return <TaskEnginePanel state={state} dispatch={dispatch} t={t} moduleFilter=""
    heroTitle={state.platformModuleNames?.Execution||t.execution}
    heroSubtitle={state.moduleSubtitles?.Execution||(locLabel?`${locLabel} · ${t.tasksSuffix}`:t.executionSubtitle)}/>;
}

export default Execution;
